import { MutableRefObject, useRef, useState } from "react";

type UsePaginationReturn = {
	page: number;
	forcePage: MutableRefObject<number>;
	isFirstRender: MutableRefObject<boolean>;
	handleNextPage: (fetchFunction: (pageToUse: number) => void) => void;
	resetPagination: () => void;
};

export function usePagination(): UsePaginationReturn {
	const [page, setPage] = useState(1);
	const forcePage = useRef(1);
	const isFirstRender = useRef(true);

	function handleNextPage(fetchFunction: (pageToUse: number) => void) {
		if (forcePage.current !== page) {
			forcePage.current += 1;
			fetchFunction(forcePage.current);
			return;
		}
		setPage(page + 1);
	}

	function resetPagination() {
		forcePage.current = 1;
		setPage(1);
	}

	return {
		page,
		forcePage,
		isFirstRender,
		handleNextPage,
		resetPagination,
	};
}
